export default __webpack_public_path__ + "static/media/spot-oncleaners.529af80e.png";